import React from 'react';
import * as AlertDialogComp from '@radix-ui/react-alert-dialog';
import './styles.css';

type Props = {
  onConfirm?: () => void;
  onCancel?: () => void;
  onOpenChange?: (open: boolean) => void;
  open?: boolean;
};
export const CancelBotDialog: React.FC<Props> = ({
  onCancel,
  onConfirm,
  onOpenChange,
  open,
}) => (
  <AlertDialogComp.Root onOpenChange={onOpenChange} open={open}>
    <AlertDialogComp.Portal>
      <AlertDialogComp.Overlay className="AlertDialogOverlay" />
      <AlertDialogComp.Content className="AlertDialogContent">
        <AlertDialogComp.Overlay className="AlertDialogOverlay" />
        <AlertDialogComp.Title className="AlertDialogTitle">
          Remove Multiplayer from this meeting?
        </AlertDialogComp.Title>
        <AlertDialogComp.Description className="AlertDialogDescription">
          The bot might still join if another participant has Multiplayer
          enabled.
        </AlertDialogComp.Description>
        <div style={{ display: 'flex', gap: 25, justifyContent: 'flex-end' }}>
          <AlertDialogComp.Cancel asChild onClick={onCancel}>
            <button className="Button cancel">Cancel</button>
          </AlertDialogComp.Cancel>
          <AlertDialogComp.Action asChild onClick={onConfirm}>
            <button className="Button red">Yes</button>
          </AlertDialogComp.Action>
        </div>
      </AlertDialogComp.Content>
    </AlertDialogComp.Portal>
  </AlertDialogComp.Root>
);
